import AudioContainer from './record-audio.container'

export default AudioContainer
